import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const useAnimation = (active: boolean, refs: React.RefObject<HTMLElement>[]) => {
  const doms = useRef<HTMLElement[]>([]);

  useEffect(() => {
    refs.forEach(ref => ref.current && doms.current.push(ref.current));
    return () => { doms.current.length = 0 }
  }, []);

  useEffect(() => {
    if (active) {
      gsap.to(doms.current, {
        duration: 0.75,
        ease: "power2.out",
        stagger: 0.15,
        y: 0,
        opacity: 1,
        visibility: "visible",
        display: "block"
      });
    } else {
      gsap.to(doms.current, {
        duration: 0,
        overwrite: true,
        y: 100,
        opacity: 0,
        visibility: "hidden",
        display: "none"
      });
    }
  }, [active]);
}

export default useAnimation;